/**
 * @generated SignedSource<<93e6651b7b5ad9ef48f9e05c84cd7314>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addPricingRulePanel_PricingsListQuery$variables = Record<PropertyKey, never>;
export type addPricingRulePanel_PricingsListQuery$data = {
  readonly pricings: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly pricingID: number;
        readonly pricingName: string;
      };
    }> | null;
  } | null;
};
export type addPricingRulePanel_PricingsListQuery = {
  response: addPricingRulePanel_PricingsListQuery$data;
  variables: addPricingRulePanel_PricingsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      }
    ],
    "concreteType": "PricingsConnection",
    "kind": "LinkedField",
    "name": "pricings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PricingsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PricingGroup",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pricingName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pricingID",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "pricings(first:200)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addPricingRulePanel_PricingsListQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addPricingRulePanel_PricingsListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "652141b35d0fe1327393450b0801673b",
    "id": null,
    "metadata": {},
    "name": "addPricingRulePanel_PricingsListQuery",
    "operationKind": "query",
    "text": "query addPricingRulePanel_PricingsListQuery {\n  pricings(first: 200) {\n    edges {\n      node {\n        id\n        pricingName\n        pricingID\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "69317230d9f7067e462fbea279567464";

export default node;
